"use strict";

exports.__esModule = true;
exports["default"] = void 0;
var IMAGE_RESIZE = {
  CROP: 'fill',
  FIT: 'fit'
};
var _default = IMAGE_RESIZE;
exports["default"] = _default;